import React, { useEffect, useState } from 'react';
import {
  Container,
  SelectedTab,
  SelectedTabText,
  SelectTabWrapper,
  Table,
  TeamLogo,
  TeamName,
  TeamWrapper,
  Title
} from './styled';
import moment from 'moment';
import 'moment/locale/ko';
import homeDefault from 'images/sports/common/logo_home.png';
import awayDefault from 'images/sports/common/logo_away.png';
import SportsTeamLogo from '../../../../../../components/teamLogo';

const NextMatch = ({ data, gameData }) => {
  const [selectedPosition, setSelectedPosition] = useState('home');
  const [viewList, setViewList] = useState([]);
  const { nextHomeRecord, nextAwayRecord } = data;
  const teamData = gameData.detail.getTeamData || null;
  const selectedTeamName = teamData && teamData[selectedPosition].name;
  const handleChangePosition = (position) => {
    setSelectedPosition(position);
    if (position === 'home') {
      setViewList(nextHomeRecord);
    } else {
      setViewList(nextAwayRecord);
    }
  };

  useEffect(() => {
    if (nextHomeRecord.length > 0) {
      handleChangePosition('home');
    } else if (nextHomeRecord.length === 0 && nextAwayRecord.length > 0) {
      handleChangePosition('away');
    }
  }, []);

  if (nextHomeRecord.length === 0 && nextAwayRecord.length === 0) {
    return null;
  }
  return (
    <Container>
      <Title>다음일정</Title>
      <SelectTabWrapper>
        <SelectedTab
          isSelected={selectedPosition === 'home'}
          onClick={() => handleChangePosition('home')}
        >
          <SelectedTabText>{teamData && teamData.home.name}</SelectedTabText>
        </SelectedTab>
        <SelectedTab
          isSelected={selectedPosition === 'away'}
          onClick={() => handleChangePosition('away')}
        >
          <SelectedTabText>{teamData && teamData.away.name}</SelectedTabText>
        </SelectedTab>
      </SelectTabWrapper>
      <Table>
        <colgroup>
          <col width={125} />
          <col width={80} />
          <col width={125} />
        </colgroup>
        <tbody>
          {viewList.map((value, key) => {
            const { home, away, startDateTime } = value;
            const formattedDateTime = moment(startDateTime)
              .locale('ko')
              .format('MM.DD (ddd) HH:ss');

            return (
              <tr key={key}>
                <td>
                  <TeamWrapper>
                    <TeamName isSelected={home.name === selectedTeamName}>
                      {home.name}
                    </TeamName>
                    <TeamLogo>
                      {home.imgPath !== null ? (
                        <SportsTeamLogo
                          imgSize={'33'}
                          imgUrl={home.imgPath}
                          isLazy={false}
                          location={'home'}
                        />
                      ) : (
                        <img
                          src={homeDefault}
                          alt={`${home.name} 로고 이미지`}
                        />
                      )}
                    </TeamLogo>
                  </TeamWrapper>
                </td>
                <td>{formattedDateTime}</td>
                <td>
                  <TeamWrapper>
                    <TeamLogo>
                      {away.imgPath !== null ? (
                        <SportsTeamLogo
                          imgSize={'33'}
                          imgUrl={away.imgPath}
                          isLazy={false}
                          location={'away'}
                        />
                      ) : (
                        <img
                          src={awayDefault}
                          alt={`${away.name} 로고 이미지`}
                        />
                      )}
                    </TeamLogo>
                    <TeamName isSelected={away.name === selectedTeamName}>
                      {away.name}
                    </TeamName>
                  </TeamWrapper>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export default NextMatch;
